import React from 'react'
import { browserHistory } from 'react-router'
import classes from './GameList.scss'

class GameItem extends React.Component {

  render () {
    const { id, first, second, third, fourth, fifth, opponent, onClick, won, lost, star } = this.props
    const gameItemClasses = [classes.gameItem, won && classes.won, lost && classes.lost].join(' ')

    return (
      <li className={gameItemClasses} onClick={onClick}>
        <span className={star && classes.star}>{first}</span>
        <span>{second}</span>
        {third !== undefined && <span>{third}</span>}
        {fourth !== undefined && <span>{fourth}</span>}
        {fifth !== undefined && <span>{fifth}</span>}
      </li>
    )
  }
}

export default GameItem



/** WEBPACK FOOTER **
 ** ./src/components/GameList/GameItem.js
 **/